module.exports = __webpack_public_path__ + "img/exam-2.713c64e3.png";